"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("@turf/helpers");
var distance_1 = __importDefault(require("@turf/distance"));
var ngraph_path_1 = __importDefault(require("ngraph.path"));
var utils_1 = require("./utils");
// TODO: update it such that it handles additional options in the same way as find-many
var singleRouteCalculator = function (graph, waypoints, options, units) {
    if (units === void 0) { units = "kilometers"; }
    var _start = waypoints[0], _finish = waypoints[1];
    // 1. Process the start and finish points in the event that it crosses the 180 degree meridian
    var _a = (0, utils_1.processMeridianCrossing)(_start, _finish), _b = _a.coord, start = _b[0], finish = _b[1], changed = _a.changed, direction = _a.direction;
    // 2. Identify the graph to be used based on the direction in step 1
    var useGraph = graph.mainGraph;
    if (changed && direction === "LTR") {
        useGraph = graph.positiveGraph;
    }
    if (changed && direction === "RTL") {
        useGraph = graph.negativeGraph;
    }
    // 3. Identify the nearest coordinate within the vertice
    var nearestStart = (0, utils_1.getNearestNeighbour)(start, useGraph.vertices);
    var nearestFinish = (0, utils_1.getNearestNeighbour)(finish, useGraph.vertices);
    // If the nearest neighbour cannot be found stop the calculation
    if (!nearestStart || !nearestFinish)
        return false;
    // 4. Select the path finding algorithm to use
    var aStarFunc = ngraph_path_1.default.aStar(useGraph.graph, options);
    // 5. Run the algorithm with the start and finish points
    var nodes = aStarFunc.find(nearestStart.join(","), nearestFinish.join(","));
    var paths = nodes.map(function (node) { return [
        node.data.x,
        node.data.y,
    ]; });
    // 6. Include connection to waypoint
    paths.push(_start);
    paths.unshift(_finish);
    // 7. Check if the calculated route has to be broken apart for proper display on the map
    var correctedPaths = (0, utils_1.breakMeridianPaths)(paths, direction);
    var totalDistance = correctedPaths.reduce(function (acc, groupPath) {
        var groupPathLength = groupPath.reduce(function (innerAcc, path, index) {
            if (index === 0) {
                return innerAcc;
            }
            else {
                return (innerAcc +
                    (0, distance_1.default)((0, helpers_1.point)(path), (0, helpers_1.point)(groupPath[index - 1]), {
                        units: units,
                    }));
            }
        }, 0);
        return acc + groupPathLength;
    }, 0);
    return {
        path: correctedPaths,
        distance: Math.floor(totalDistance),
    };
};
exports.default = singleRouteCalculator;
